"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SearchTermConfig',
  data: function data() {
    return {
      visible: false,
      loading: false,
      submitLoading: false,
      form: {
        minSearchCount: '',
        hotTermCount: ''
      },
      rules: {
        minSearchCount: [{
          validator: this.validatePositiveInteger,
          trigger: 'blur'
        }],
        hotTermCount: [{
          validator: this.validatePositiveInteger,
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    initOpen: function initOpen() {
      var _this = this;
      this.visible = true;
      this.getConfig();
      this.$nextTick(function () {
        _this.$refs.form && _this.$refs.form.clearValidate();
      });
    },
    getConfig: function getConfig() {
      var _this2 = this;
      this.loading = true;
      (0, _marketing.searchTermConfigInfoApi)().then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _this2.form = {
          minSearchCount: _this2.getConfigValue(res, 'searchTermSystemStatisticalNum'),
          hotTermCount: _this2.getConfigValue(res, 'searchTermAddShowNum')
        };
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    getConfigValue: function getConfigValue(data, field) {
      if (data[field] !== undefined && data[field] !== null) return data[field];
      var upperField = field.charAt(0).toUpperCase() + field.slice(1);
      return data[upperField] !== undefined && data[upperField] !== null ? data[upperField] : '';
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        _this3.submitLoading = true;
        (0, _marketing.searchTermConfigUpdateApi)({
          searchTermSystemStatisticalNum: Number(_this3.form.minSearchCount),
          searchTermAddShowNum: Number(_this3.form.hotTermCount)
        }).then(function () {
          _this3.$message.success('配置保存成功');
          _this3.submitLoading = false;
          _this3.visible = false;
        }).catch(function () {
          _this3.submitLoading = false;
        });
      });
    },
    validatePositiveInteger: function validatePositiveInteger(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入配置值'));
        return;
      }
      if (!/^[1-9]\d*$/.test(String(value))) {
        callback(new Error('请输入正整数'));
        return;
      }
      callback();
    }
  }
};